import React, { useCallback, useState } from 'react';
import Checkbox from '../../Checkbox';
import s from './ModalDoNotShowAgain.scss';
/** Control for the do not show again feature of confirm modals */
var ModalDoNotShowAgain = function (_a) {
    var onDoNotShowAgainChange = _a.onDoNotShowAgainChange, doNotShowAgainText = _a.doNotShowAgainText;
    var _b = useState(false), checked = _b[0], setChecked = _b[1];
    var onChange = useCallback(function (value) {
        setChecked(value);
        onDoNotShowAgainChange(value);
    }, [onDoNotShowAgainChange]);
    return (React.createElement("div", { className: s['root'] },
        React.createElement(Checkbox, { onChange: onChange, isChecked: checked, labelClassName: s['label'] }, doNotShowAgainText)));
};
ModalDoNotShowAgain.displayName = 'ModalDoNotShowAgain';
export default ModalDoNotShowAgain;
//# sourceMappingURL=ModalDoNotShowAgain.js.map